import React from "react";
import ApplicationGstFields from "./ApplicationGstFields";
import {
  getEffectiveCurrency,
  getEffectiveTax,
} from "../../utilis/applicationCostHelpers";

const CURRENCY_OPTIONS = [
  "AUD",
  "USD",
  "PKR",
  "CAD",
  "EUR",
  "MYR",
  "GBP",
  "SGD",
  "AED",
];

export { CURRENCY_OPTIONS };

const INLINE_LABEL = "mb-1 block text-xs font-medium text-gray-700";
const INLINE_CONTROL =
  "w-full min-w-0 rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-[#007BFF] focus:outline-none focus:ring-1 focus:ring-[#007BFF]";
const INLINE_FIELD = "cms-mig-field min-w-0";
const FORM_ROW = "cms-mig-form-row";
const FORM_ERROR = "mt-1 block text-xs font-medium text-red-500";

function ApplicationCostSection({
  cost,
  setCost,
  currency,
  setCurrency,
  tax,
  setTax,
  details,
  costError,
  currencyError,
  taxError,
  breakdown,
  effectiveCurrency,
  gstSetting,
  gstPercentage,
  applyCurrencySelection = () => {},
  baseCostLabel = "Cost:",
  totalCostLabel = "Professional Cost",
  showTotalCost = false,
  layout = "default",
  trailingContent = null,
  rowClassName,
  baseInputClassName = "form-control acc-form col-lg-6 ml-1",
  currencySelectClassName = "browser-default custom-select p-1 ml-1 col-lg-4 acc-label2",
  taxSelectClassName = "form-select acc-form",
}) {
  const currencyValue = getEffectiveCurrency(currency, details);
  const taxValue = getEffectiveTax(tax, details);

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const costLabel = baseCostLabel.replace(/:$/, "");

  if (layout === "inline") {
    const gridClass = rowClassName || FORM_ROW;
    return (
      <div className="w-full">
        <div className={gridClass}>
          <div className={INLINE_FIELD}>
            <label className={INLINE_LABEL}>{costLabel}</label>
            <input
              type="number"
              min="0.00"
              step="0.25"
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              placeholder="Enter cost"
              className={INLINE_CONTROL}
            />
          </div>

          <div className={INLINE_FIELD}>
            <label className={INLINE_LABEL}>Currency</label>
            <select
              name="currency"
              value={currencyValue}
              onChange={handleCurrencyChange}
              className={INLINE_CONTROL}
            >
              <option value="">Please Select</option>
              {CURRENCY_OPTIONS.map((code) => (
                <option key={code} value={code}>
                  {code}
                </option>
              ))}
            </select>
          </div>

          <div className={INLINE_FIELD}>
            <label className={INLINE_LABEL}>Tax</label>
            <select
              value={taxValue}
              onChange={(e) => setTax(e.target.value)}
              name="tax"
              className={INLINE_CONTROL}
            >
              <option value="">Select Tax</option>
              <option value="inclusive">Inclusive</option>
              <option value="exclusive">Exclusive</option>
              <option value="notax">No Tax</option>
            </select>
          </div>

          <ApplicationGstFields
            breakdown={breakdown}
            currency={effectiveCurrency}
            tax={taxValue}
            gstSetting={gstSetting}
            gstPercentage={gstPercentage}
            inline
            showProfessionalCostTotal={showTotalCost}
            totalCostLabel={totalCostLabel}
          />

          {trailingContent}
        </div>

        {(costError || currencyError || taxError) && (
          <div className="mt-2 space-y-0.5">
            {costError && <small className={FORM_ERROR}>{costError}</small>}
            {currencyError && <small className={FORM_ERROR}>{currencyError}</small>}
            {taxError && <small className={FORM_ERROR}>{taxError}</small>}
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="form-group col-lg-5 d-flex pl-0 flex-wrap align-items-start">
        <label className="profile-label pt-1">{baseCostLabel}</label>
        <input
          type="number"
          min="0.00"
          step="0.25"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
          placeholder="Enter cost"
          className={baseInputClassName}
        />
        {costError && <small className="error w-100 ms-1">{costError}</small>}
        {currencyError && (
          <small className="error w-100 ms-1">{currencyError}</small>
        )}

        <select
          name="currency"
          value={currencyValue}
          onChange={handleCurrencyChange}
          className={currencySelectClassName}
        >
          <option value="">Please Select</option>
          {CURRENCY_OPTIONS.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
      </div>

      <div className="col-2">
        <select
          value={taxValue}
          onChange={(e) => setTax(e.target.value)}
          name="tax"
          className={taxSelectClassName}
        >
          <option value="">Select Tax</option>
          <option value="inclusive">Inclusive</option>
          <option value="exclusive">Exclusive</option>
          <option value="notax">No Tax</option>
        </select>
        {taxError && <small className="error d-block">{taxError}</small>}
      </div>

      <ApplicationGstFields
        breakdown={breakdown}
        currency={effectiveCurrency}
        tax={taxValue}
        gstSetting={gstSetting}
        gstPercentage={gstPercentage}
        totalCostLabel={totalCostLabel}
      />
    </>
  );
}

export default ApplicationCostSection;
